import axios from "axios";

export function retryAfterSeconds(error: unknown, fallback = 60): number {
  if (!axios.isAxiosError(error) || error.response?.status !== 429) return 0;
  const value = error.response.headers?.["retry-after"];
  if (value !== undefined) {
    const seconds = Number(value);
    if (Number.isFinite(seconds)) return Math.max(1, Math.ceil(seconds));
    const date = Date.parse(String(value));
    if (Number.isFinite(date)) return Math.max(1, Math.ceil((date - Date.now()) / 1000));
  }
  return fallback;
}

/** Extracts a human-readable message from axios / API errors. */
export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (!axios.isAxiosError(error)) {
    if (error instanceof Error && error.message) return error.message;
    return fallback;
  }

  const data = error.response?.data as
    | { message?: string | string[]; error?: string }
    | undefined;

  if (!data) {
    return error.message || fallback;
  }

  if (Array.isArray(data.message)) {
    return data.message.join(", ");
  }
  if (typeof data.message === "string" && data.message.trim()) {
    return data.message;
  }
  if (typeof data.error === "string" && data.error.trim()) {
    return data.error;
  }

  return error.message || fallback;
}
